import React from 'react';
import { MagnifyingGlass } from '@phosphor-icons/react';
import {
    SearchContainer,
    SearchInput,
    SearchButton,
} from './styles';

export default function SearchInternational({
  value,
  onChange,
  placeholder = 'Buscar',
  onSearch,
}) {
  return (
    <SearchContainer>
      <SearchInput
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />

      <SearchButton type="button" onClick={onSearch}>
        <MagnifyingGlass />
      </SearchButton>
    </SearchContainer>
  );
}